import React from 'react'

const baseStyles =
  'autocomplete-result-item text-base font-normal flex flex-row items-center p-4 rounded-2xl'

const ResultItem = ({ children, className = '' }) => {
  return <span className={`${baseStyles} ${className}`}>{children}</span>
}
export default ResultItem
